module.exports = new __parcel__URL__("error.43445e70.svg").toString();